// -----  环境配置  -----
// let baseApi = import.meta.env.VUE_APP_BASE_API
let baseApi = process.env.VUE_APP_BASE_API
// 根据手机设备类型获取下载地址
let getVersionType = `${baseApi}/api-user/applets/version/current`

// 查询3D视图配置 post
const stationViewPost = (stationId) =>
  `${baseApi}/api-monitor/monitor/station/ext/${stationId}`

// 查询3D视图配置-通过获取文件 /api-monitor/monitor/station/view/{stationId}
const stationDownloadView = (stationId) =>
  `${baseApi}/api-monitor/monitor/station/view/${stationId}`

export default {
  getVersionType,
  stationViewPost,
  stationDownloadView
}
